export { default } from "./src/price-calculator";

export type { UniformPricingCalculatorProps } from "./src/price-calculator";
